import { api } from "../services/api";

export function setAuthorizationHeader(token: string | null) {
  return api.defaults.headers.common.Authorization = token;
}

export function deleteAuthorizationHeader() {
  delete api.defaults.headers.common.Authorization;
}

export function setAuthorizationToken(
  accessToken: string,
  typeToken: string = 'Bearer'
): void {
  if (!accessToken) {
    localStorage.removeItem('@WhatsCodex:token');
    return deleteAuthorizationHeader();
  }

  localStorage.setItem('@WhatsCodex:token', accessToken);
  setAuthorizationHeader(`${typeToken} ${accessToken}`);
}

export function getAuthorizationToken(
  typeToken: string = 'Bearer'
): string | null {
  const token = localStorage.getItem('@WhatsCodex:token');

  if (token) {
    setAuthorizationHeader(`${typeToken} ${token}`);
  } else {
    deleteAuthorizationToken();
  }

  return token;
}

export function deleteAuthorizationToken() {
  localStorage.removeItem('@WhatsCodex:token');
}

export function saveTokenAdmin(): void {
  let tokenAdmin = getTokenAdmin();
  if (tokenAdmin)
    return
  tokenAdmin = getAuthorizationToken();
  localStorage.setItem('@WhatsCodex:tokenAdmin', tokenAdmin || '');
}

export function getTokenAdmin(): string | null {
  return localStorage.getItem('@WhatsCodex:tokenAdmin');
}

export function deleteTokenAdmin(): void {
  localStorage.removeItem('@WhatsCodex:tokenAdmin');
}

export function saveUserImpersonate(token: string): void {
  localStorage.setItem('@WhatsCodex:impersonate', token);
}

export function getUserImpersonate(): string | null {
  return localStorage.getItem('@WhatsCodex:impersonate');
}

export function deleteUserImpersonate(): void {
  localStorage.removeItem('@WhatsCodex:impersonate');
}

export async function changeTokenUser(userId: string) {
  try {
    const userPrevious = getUserImpersonate();

    const response = await api.post('/users/impersonate/' + userId, {
      userPrevious: userPrevious,
    });
    const newToken = response.data.token;

    saveTokenAdmin();
    saveUserImpersonate(userId);
    setAuthorizationToken(newToken);

    window.location.reload();
  } catch (error) {
    console.error('Erro ao impersonar usuário:', error);
  }
}

export function returnTokenAdmin() {
  try {
    api.post('/users/stop-impersonate/' + getUserImpersonate());

    setAuthorizationToken(getTokenAdmin() || '');
    deleteTokenAdmin();
    deleteUserImpersonate();

    window.location.reload();
  } catch (error) {
    console.error('Erro ao retornar ao administrador:', error);
  }
}